import {
  BNCC,
  ClassInfo,
  CurricularComponent,
  GetEnemSkillsParams,
  GetEnemSkillsResponse,
  Grade,
} from '../../types/School';
import { cosmosApi } from '../cosmosAPi';
import { getApi } from '../getApi/index';

export const getGrades = async (
  school_id: number,
  profileId: number,
): Promise<Grade[]> => {
  const { data } = await getApi().get<Grade[]>(
    `/options/grades?schoolId=${school_id}&profileId=${profileId}`,
  );
  return data;
};

export const getTeacherInfo = async (school_id: number): Promise<ClassInfo[]> => {
  const { data } = await getApi().get<ClassInfo[]>(
    `teacher/info?schoolId=${school_id}`,
  );
  return data;
};

export const getCurricularComponents = async (
  school_id?: number,
  profile_id?: number,
  class_id?: number,
): Promise<CurricularComponent[]> => {
  const shouldUseBffParams = profile_id === 4;
  const { data } = await (shouldUseBffParams
    ? getApi().get<CurricularComponent[]>(`/options/curricular-components`, {
        params: {
          ...(school_id != null ? { schoolId: school_id } : {}),
          ...(profile_id != null ? { profileId: profile_id } : {}),
          ...(class_id != null ? { classId: class_id } : {}),
        },
      })
    : getApi().get<CurricularComponent[]>(
        `/options/curricular-components?schoolId=${school_id}&profileId=${profile_id}&classId=${class_id}`,
      ));
  return data;
};

export const getBNCCByAreaId = async (componentId?: number, gradeId?: number) => {
  const { data } = await getApi().get<BNCC[]>(
    `/options/bncc?componentId=${componentId}`,
    {
      params: {
        gradeId: gradeId,
      },
    },
  );
  return data;
};

export const getEnemSkills = async ({
  itemsPerPage,
  page,
  knowledge_area_references_ids,
  segmentsIds,
}: GetEnemSkillsParams = {}) => {
  const { data } = await cosmosApi().get<GetEnemSkillsResponse>(
    '/v1/enem-classification',
    {
      params: {
        items_per_page: itemsPerPage,
        page,
        knowledge_area_references_ids: knowledge_area_references_ids,
        segments_ids: segmentsIds,
      },
    },
  );

  return data;
};
